import React, { useEffect, useId, useRef, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Header.css";
import logo from "../../Assets/EMEIlogos.png";
import { Link } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuId = useId();
  const navRef = useRef(null);
  const toggleRef = useRef(null);
  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 1025px)");
    const closeOnDesktop = () => { if (desktop.matches) setMenuOpen(false); };
    desktop.addEventListener("change", closeOnDesktop);
    return () => desktop.removeEventListener("change", closeOnDesktop);
  }, []);
  useEffect(() => {
    if (!menuOpen) return;
    const onPointerDown = (event) => {
      if (!navRef.current?.contains(event.target)) setMenuOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        toggleRef.current?.focus();
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [menuOpen]);
  return (
<header className="header">
  <div
    className="sec1_container_header"
    data-aos="fade-down"
    data-aos-duration="650"
    data-aos-once="true"
  >
    <nav className="navbar" ref={navRef} aria-label="Main navigation">

      <div
        className="logo"
        data-aos="fade-right"
        data-aos-duration="600"
        data-aos-delay="100"
        data-aos-once="true"
      >
       <img
    src={logo}
    alt="EMEI logo"
  />



      </div>

      <button type="button" className="home-nav-toggle" ref={toggleRef}
        aria-expanded={menuOpen} aria-controls={menuId}
        aria-label={menuOpen ? "Close navigation" : "Open navigation"}
        onClick={() => setMenuOpen((open) => !open)}>
        {menuOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}
      </button>
      <ul id={menuId} className={`nav-links${menuOpen ? " nav-links--open" : ""}`}
        onClick={(event) => { if (event.target.closest("a")) setMenuOpen(false); }}>

        <li
          data-aos="fade-down"
          data-aos-duration="550"
          data-aos-delay="100"
          data-aos-once="true"
        >
          <Link to="/">Home</Link>
        </li>

        <li
          data-aos="fade-down"
          data-aos-duration="550"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <Link to="/about">About Us</Link>
        </li>

        <li
          data-aos="fade-down"
          data-aos-duration="550"
          data-aos-delay="200"
          data-aos-once="true"
        >
          <Link to="/courses">Courses</Link>
        </li>
        <li data-aos="fade-down" data-aos-duration="550" data-aos-delay="225" data-aos-once="true">
          <Link to="/career">Career</Link>
        </li>

        <li
          data-aos="fade-down"
          data-aos-duration="550"
          data-aos-delay="250"
          data-aos-once="true"
        >
          <Link to="/gallery">Gallery</Link>
        </li>

        <li
          data-aos="fade-left"
          data-aos-duration="550"
          data-aos-delay="300"
          data-aos-once="true"
        >
          <Link to="/login">
            <button className="upper_join-btn">
              Join Now
            </button>
          </Link>
        </li>

      </ul>

    </nav>
  </div>



  <div className="hero">

    {/* <p
      className="subtitle"
      data-aos="fade-up"
      data-aos-duration="650"
      data-aos-delay="150"
      data-aos-once="true"
    >
touch the world of success    </p> */}

    <h1
      className="header-quote"
      data-aos="fade-up"
      data-aos-duration="700"
      data-aos-delay="250"
      data-aos-once="true"
    >
      <span className="header-quote-mark" aria-hidden="true">“</span>
      <span className="header-quote-line">Touch the world</span>{" "}
      <span className="header-quote-accent">of success.</span>
      <span className="header-quote-closing" aria-hidden="true">”</span>
    </h1>

  </div>

</header>
  );
}
